import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { sideBarClose, sideBarOpen } from "../redux/sidebar/sidebarSlice";

//icons
import { MdDashboard, MdFindReplace } from "react-icons/md";
import { GiTyre, GiMechanicGarage } from "react-icons/gi";
import { SiConstruct3, SiCircle } from "react-icons/si";
import { BiBuildings } from "react-icons/bi";
import { FaUsers, FaBus, FaSync } from "react-icons/fa";
import { FcInspection } from "react-icons/fc";
import { BsFillCalendarWeekFill } from "react-icons/bs";
import { RiListSettingsLine, RiProductHuntLine } from "react-icons/ri";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { FaUser } from "react-icons/fa";

import {
  MdClass,
  MdChevronLeft,
  MdChevronRight,
  MdExpandMore,
  MdExpandLess,
  MdAdd,
} from "react-icons/md";
import { GiDustCloud } from "react-icons/gi";
import { HiDocumentReport } from "react-icons/hi";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import { BiTransfer } from "react-icons/bi";
import { IoMdResize } from "react-icons/io";
import { AiTwotoneMail } from "react-icons/ai";
import { createDocument } from "apis/customApiHandler";
import store from "../redux/store";
import { fetchUser } from "../redux/user/userSlice";
import { useGlobalDarkMode } from "hooks/useDarkMode";

const Sidebar = () => {
  const sideBarState = useSelector((state) => state.sidebar.sideBarState);
  const currentUser = useSelector((state) => state.user.currentUser);
  // const currentUser = JSON.parse(localStorage.getItem("user"))
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const isDarkModeActive = useGlobalDarkMode();
  
  // Check if we're on stencils page and dark mode is active
  const isStencilsPage = location.pathname === '/stencils';
  const [stencilMenuExpand, setStencilMenuExpand] = useState(false);
  const [emailMenuExpanded, setEmailMenuExpanded] = useState(false);
  const [operationalMenuExpanded, setOperationalMenuExpanded] = useState(false);
  const [pendingActionsMenuExpanded, setPendingActionsMenuExpanded] = useState(false);
  const [vehicleDetailsMenuExpanded, setVehicleDetailsMenuExpanded] = useState(false);
  const [wheelAndAlignmentMenuExpanded, setWheelAndAlignmentMenuExpanded] = useState(false);
  const [cpkmMenuExpanded, setCpkmMenuExpanded] = useState(false);
  const [stockNotification, setStockNotification] = useState(null)
  // console.log("user", currentUser.userRole.permissions)


  const dispatch = useDispatch();

  const [matches, setMatches] = useState(window.matchMedia("(max-width: 769px)").matches);

  //Redux-toolkit
  useEffect(() => {
    const currentUser = store.getState().user.currentUser;
    if(currentUser){

      dispatch(fetchUser());
      console.log("Inside Fetch")
    }

  }, [dispatch]); 

  // cDM, cDU

  useEffect(() => {
    let media = window.matchMedia("(max-width: 768px)");
  
    const handleMediaChange = () => {
      if (media.matches) {
        dispatch(sideBarClose());
      } else {
        dispatch(sideBarOpen());
      }
    };
  
    handleMediaChange();
  
    media.addEventListener("change", handleMediaChange);
  
    return () => {
      media.removeEventListener("change", handleMediaChange);
    };
  }, [dispatch]);

  const getData = async (pg, download = false) => {
    // setLoading(true);
    try {
      const response = await createDocument("/tyre/externalStockTansfers", {
        fetchIncomingRequests: true,
      });
      setStockNotification(response?.paginate.total);
    } catch (err) {
      // setDownloadData(response.data)
      //console.log({err})
    }finally{
      // setLoading(false);
    }
  };

  useEffect(()=>{
    // for handling the no of open requests for stock transfers
    const hasPermission = checkPermission([permissions.manage_stencil_search, permissions.manage_stencil_menu, permissions.stock_transfer, permissions.external_stock_transfer], currentUser)
    if(hasPermission) getData();
  }, [currentUser])



  const menu = [
    {
      title: "Fleet Operations",
      icon: <MdDashboard />,
      active: false,
      link: "/dashboard",
      permissions: [
        permissions.view_dashboard,
      ],
    },
    {
      title: "Mobility Technical",
      icon: <MdDashboard />,
      active: false,
      link: "/mobility-dashboard",
      permissions: [
        permissions.view_mobility_dashboard,
      ],
    },
    {
      title: "Scrap and Casing Tyres",
      icon: <SiConstruct3 />,
      active: false,
      link: "/scrap-dashboard",
      permissions: [permissions.view_scraping_casing_dashboard],
    },
    {
      title: "Users",
      icon: <FaUsers />,
      active: false,
      link: "/users",
      permissions: [permissions.manage_users, permissions.view_users],
    },
    {
      title: "Roles & Permissions",
      icon: <RiListSettingsLine />,
      active: false,
      link: "/permisssions",
      permissions: [
        permissions.view_roles_and_permissions,
        permissions.manage_roles_and_permissions,
      ],
    },
    {
      title: "Email Alerts",
      icon: <AiTwotoneMail />,
      active: false,
      link: "/email-alerts",
      permissions: [permissions.view_email, permissions.manage_email],
    },
    {
      title: "Vehicles",
      icon: <FaBus />,
      active: false,
      link: "/vehicles",
      permissions: [permissions.manage_vehicles, permissions.view_vehicles],
    },
    {
      title: "DTP Planning",
      icon: <HiDocumentReport />,
      active: false,
      link: "/dtp-planning",
      permissions: [permissions.view_reports, permissions.view_dtp_plan],
    },
    {
      title: "CPKM Upload",
      icon: <HiDocumentReport />,
      active: false,
      link: "/cpkm-upload",
      permissions: [permissions.upload_cpkm, permissions.view_cpkm, permissions.delete_cpkm, ],
    },
    {
      title: "Download Section",
      icon: <FaCloudDownloadAlt />,
      active: false,
      link: "/mail-logger",
      permissions: [],
    },

  ];
  

  const stencilMenu = [
    {
      title: "All Stencils",
      icon: <SiConstruct3 />,
      active: false,
      link: "/stencils",
      permissions: [permissions.view_stencil_menu, permissions.manage_stencil_menu, permissions.view_stencil_search, permissions.manage_stencil_search],
    },
    {
      title: "Change Log",
      icon: <VscGitPullRequestGoToChanges />,
      active: false,
      link: "/logs",
      permissions: [permissions.view_stencil_menu, permissions.manage_stencil_menu, ],
    },
    {
      title: "Stock Transfers", 
      icon: <BiTransfer />,
      active: false,
      link: "/stock-transfer",
      permissions: [permissions.manage_stencil_search, permissions.manage_stencil_menu, permissions.stock_transfer, permissions.external_stock_transfer],
      badge: stockNotification && <div className= "bg-red-600 text-white rounded-full h-5 w-5 text-xs text-center align-center items-center p-auto ">
        {stockNotification ?? 0}
      </div>

    },
    // {
    //   title: "External Stock Tansfer History",
    //   icon: <BsFillCalendarWeekFill />,
    //   active: false,
    //   link: "/external-stock-transfer-history",
    //   permissions: [permissions.view_stencil_menu, permissions.manage_stencil_menu, permissions.external_stock_transfer, permissions.approve_external_stock_transfer ],
    // },
    {
      title: "Non CPKM Tyres",
      icon: <SiCircle />,
      active : false,
      link: "/tyres",
      permissions: [permissions.view_stencil_menu, permissions.view_non_cpkm_tyres, permissions.manage_non_cpkm_tyres, permissions.manage_stencil_menu, ],
    },
    {
      title: "Retread Requests (Approval)", 
      icon: <GiTyre />,
      active: false,
      link: "/retread-requests",
      permissions: [permissions.view_retread_request, permissions.approve_retread_request, permissions.dispatch_retread_request, ],
    },
  ];

  const masterMenu = [
    {
      title: "Sync Masters",
      icon: <FaSync />,
      active: false,
      link: "/sync-masters",
      permissions: [permissions.manage_masters],
    },
    {
      title: "Fleet Master",
      icon: <MdClass />,
      active: false,
      link: "/fleets",
      permissions: [permissions.view_masters, permissions.manage_masters, permissions.view_fleet_master],
    },
    {
      title: "Fleet & Hub Mapping Master",
      icon: <MdClass />,
      active: false,
      link: "/fleet-hub-mapping-master",
      permissions: [permissions.view_masters, permissions.manage_masters, ],
    },
    {
      title: "Material Master",
      icon: <MdClass />,
      active: false,
      link: "/material-master",
      permissions: [permissions.view_masters, permissions.manage_masters, ],
    },
    {
      title: "Contract Types",
      icon: <MdClass />,
      active: false,
      link: "/contract-types",
      permissions: [permissions.view_masters, permissions.manage_masters, ],
    },
    // {
    //   title: "Contract Master",
    //   icon: <MdClass />,
    //   active: false,
    //   link: "/contract-master",
    //   permissions: [permissions.view_masters, permissions.manage_masters, ],
    // },
    {
      title: "Application Types",
      icon: <MdClass />,
      active: false,
      link: "/application-types",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Mechanical Conditions",
      icon: <GiMechanicGarage />,
      active: false,
      link: "/mechanical-conditions",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Mechanical Conditions Reasons",
      icon: <GiMechanicGarage />,
      active: false,
      link: "/mechanical-conditions-reasons-master",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Body Types",
      icon: <RiListSettingsLine />,
      active: false,
      link: "/body-types",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Vehicle Types",
      icon: <FaBus />,
      active: false,
      link: "/vehicle-types",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Vehicle Make",
      icon: <FaBus />,
      active: false,
      link: "/vehicle-make-master",
            permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    
    {
      title: "Vehicle Model",
      icon: <FaBus />,
      active: false,
      link: "/vehicle-model-master",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Vehicle Configuration",
      icon: <FaBus />,
      active: false,
      link: "/vehicle-configuration-master",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Inspection Observations",
      icon: <FcInspection />,
      active: false,
      link: "/inspection-observation",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Inspection Actionables",
      icon: <FcInspection />,
      active: false,
      link: "/inspection-actionable",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Replacement Reasons",
      icon: <MdFindReplace />,
      active: false,
      link: "/tyre-replacement-reason",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Alignment Centers",
      icon: <MdFindReplace />,
      active: false,
      link: "/alignment-center",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Scrap Reasons",
      icon: <GiDustCloud />,
      active: false,
      link: "/scrap-reason",
      permissions: [permissions.view_masters, permissions.manage_masters, ],
    },
    {
      title: "Tyre Locations",
      icon: <GiDustCloud />,
      active: false,
      link: "/tyre-locations",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Casing Types",
      icon: <MdClass />,
      active: false,
      link: "/casing-types",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Company Master",
      icon: <BiBuildings />,
      active: false,
      link: "/company-master",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Product Master",
      icon: <RiProductHuntLine />,
      active: false,
      link: "/product-master",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Size Master (Retread NSD)",
      icon: <IoMdResize />,
      active: false,
      link: "/size-master",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Vendor Master",
      icon: <MdClass />,
      active: false,
      link: "/vendor-master",
      permissions: [permissions.view_masters, permissions.manage_masters, ],

    },
    {
      title: "Training Materials",
      icon: <MdClass />,
      active: false,
      link: "/training-materials",
      permissions: [permissions.view_training_material],
    },
    {
      title: "DTP Discussion Points",
      icon: <MdClass />,
      active: false,
      link: "/dtp-points",
      permissions: [permissions.view_dtp_points],
    },
  ];

  const subMenu = [
    // {
    //   title: "IGRN Approval",
    //   icon: <HiDocumentReport />,
    //   active: false,
    //   link: "/igrn-approval",
    //   permissions: [permissions.view_reports, permissions.view_igrn_approval_report],
    // },
    // {
    //   title: "TWC Issues",
    //   icon: <HiDocumentReport />,
    //   active: false,
    //   link: "/twc-issues",
    //   permissions: [permissions.view_reports, permissions.manage_retread, permissions.view_twc_issues, permissions.manage_twc_issues],
    // },
    // {
    //   title: "GRN Rejected Region Wise",

    //   icon: <HiDocumentReport />,
    //   active: false,
    //   link: "/grnRejectStatusLastFourMonthsFleetWise",
    //   permissions: [permissions.view_reports, permissions.view_grn_rejected_report],
    // },
    // {
    //   title: "Create De-Enrollment",
    //   icon: <HiDocumentReport />,
    //   active: false,
    //   link: "/create-de-enrollment",
    //   permissions: [permissions.view_reports, permissions.manage_deenrollment],
    // },
  ];

  const emailMenu = [
    {
      title: "Fleet Stock Summary",
      icon: <HiDocumentReport />,
      active: false,
      link: "/daily-stencil-details",
      permissions: [permissions.view_masters, permissions.manage_masters],
    },
    {
      title: "Fitment Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/daily-inspection-report",
      permissions: [permissions.view_masters, permissions.manage_masters],
    },
    {
      title: "GRN Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/daily-fmgrn-report",
      permissions: [permissions.view_masters, permissions.manage_masters],
    },
  ];

  const operationalMenu = [
    {
      title: "GRN Status",
      icon: <HiDocumentReport />,
      active: false,
      link: "/grnStatusLastFourMonths",
      permissions: [permissions.view_reports, permissions.view_grn_status_report, permissions.manage_grns],
    },
    {
      title: "GRN Pending Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/grnPendingReport",
      permissions: [permissions.view_reports, permissions.view_grn_pending_report],
    },
    {
      title: "Month Wise Tyre Supply Trend",
      icon: <HiDocumentReport />,
      active: false,
      link: "/month-wise-tyre-trend-report",
      permissions: [permissions.view_reports, permissions.view_month_wise_tyre_trend_report],
    },
    {
      title: "Fleet Wise Stock Details",
      icon: <HiDocumentReport />,
      active: false,
      link: "/fleetStockDetails",
      permissions: [permissions.view_reports, permissions.view_fleet_wise_stock_report],
    },
    {
      title: "On Wheel Stencil Details",
      icon: <HiDocumentReport />,
      active: false,
      link: "/onwheeldetails",
      permissions: [permissions.view_reports, permissions.view_onwheel_stencil_report],
    },
    {
      title: "Inspection Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/inspection-report",
      permissions: [permissions.view_reports, permissions.view_inspection_report],
    },
    {
      title: "Daily Tyre Replacement",
      icon: <HiDocumentReport />,
      active: false,
      link: "/dailyTyreReplacement",
      permissions: [permissions.view_reports, permissions.daily_tyre_replacement_report],
    },
    {
      title: "Scrap Analysis",
      icon: <HiDocumentReport />,
      active: false,
      link: "/scrap-analysis",
      permissions: [permissions.view_reports, permissions.view_scrap_analysis_report],
    },
    {
      title: "Stock Transfer Report",
      icon: <BiTransfer />,
      active: false,
      link: "/external-stock-transfers",
      permissions: [permissions.view_reports, permissions.manage_stencil_search, permissions.manage_stencil_menu, permissions.external_stock_transfer],
    },
    {
      title: "Tyre Validation Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/tyre-validation-report",
      permissions: [permissions.view_reports, permissions.view_tyre_validation, permissions.manage_tyre_validation],
    },  
    {
      title: "Casing And Sold Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/soldAndCasingReport",
      permissions: [permissions.view_reports, permissions.view_tyre_validation, permissions.manage_tyre_validation],
    },  
    {
      title: "Inspection Trend",
      icon: <HiDocumentReport />,
      active: false,
      link: "/inspection-summary",
      permissions: [permissions.view_reports, permissions.view_inspection_trend_report],
    },
    // {
    //   title: "Fleet Inspection History Report",
    //   icon: <HiDocumentReport />,
    //   active: false,
    //   link: "/vehicle-fleet-report",
    //   permissions: [permissions.view_reports, permissions.view_fleet_inspection_history_report],
    // },
    {
      title: "Mechanical Issue Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/mechanical-issue-report",
      permissions: [permissions.view_mechancial_issue_report, permissions.view_reports],
    },
    {
      title: "CPKM Trend Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/cpkm-trend-report",
      permissions: [permissions.view_reports, permissions.view_cpkm_report],
    },
    {
      title: "Batch Wise Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/batchWiseReport",
      permissions: [permissions.view_reports, permissions.view_batch_wise_report],
    },
  ];

  const pendingActionsMenu=[
    {
      title: "Inspection Pending",
      icon: <HiDocumentReport />,
      active: false,
      link: "/inspectionPendingOver90Days",
      permissions: [permissions.view_reports, permissions.view_inspection_pending_report],
    },
    {
      title: "Rotation Pending",
      icon: <HiDocumentReport />,
      active: false,
      link: "/rotationPending",
      permissions: [permissions.view_reports, permissions.view_rotation_pending_report],
    },
    {
      title: "Alignment Pending",
      icon: <HiDocumentReport />,
      active: false,
      link: "/alignmentPending",
      permissions: [permissions.view_reports, permissions.view_alignment_pending_report],
    },
    {
      title: "Manage DTP",
      icon: <HiDocumentReport />,
      active: false,
      link: "/manage-dtp",
      permissions: [permissions.view_reports, permissions.view_dtp],
    },
  ]

  const vehicleAndDetailsMenu=[
    {
      title: "Vehicle Enrolment Details",
      icon: <HiDocumentReport />,
      active: false,
      link: "/vehicleEnrollmentDetails",
      permissions: [permissions.view_reports, permissions.view_vehicle_enrollment_report],
    },
    {
      title: "Vehicle De-Enrolment Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/vehicle-de-enrollment-report",
      permissions: [permissions.view_reports, permissions.view_deenrollment, permissions.manage_deenrollment],
    },
  ]

  const wheelAndAlignmentMenu=[
    {
      title: "Wheel Alignment Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/wheelAlignmentReport",
      permissions: [permissions.view_reports, permissions.view_wheel_alignment_report],
    },
    {
      title: "Wheel Alignment Summary",
      icon: <HiDocumentReport />,
      active: false,
      link: "/wheelAlignmentInLastFourMonths",
      permissions: [permissions.view_reports, permissions.view_wheel_alignment_summary_report],
    },
  ]

  const cpkmMenu = [
    {
      title: "CPKM Upload",
      icon: <HiDocumentReport />,
      active: false,
      link: "/cpkm-upload",
      permissions: [permissions.view_reports, permissions.upload_cpkm, permissions.view_cpkm, permissions.delete_cpkm, ],
    },
    {
      title: "CPKM Trend Report",
      icon: <HiDocumentReport />,
      active: false,
      link: "/cpkm-trend-report",
      permissions: [permissions.view_reports, permissions.view_cpkm_report],
    }
  ];

  console.log('currentUser',currentUser,'masterMenu--',masterMenu)  

  return (
    <div
      className={`${
        sideBarState ? "w-64" : "w-16"
      } fixed h-full overflow-y-auto bg-gray-50 text-gray-600 border-r-1 border-gray-100 shadow-lg sidebar ${
        isStencilsPage && isDarkModeActive ? 'dark-mode-active' : ''
      }`}
    >
      <div className= "h-full relative">
      <div className="text-2xl font-semibold text-white w-full  h-16 bg-green-500 py-3 flex items-center ">
        {sideBarState && <div className="flex flex-col p-2">
          <div className="text-[18px] italic flex flex-row gap-2">
            {/* <img src="./icons/mobility.png" className="h-8 w-8 "></img> */}
            FLEET </div>
          <div className="text-[14px] font-normal flex flex-row items-center justify-start gap-2 "> <FaUser className="h-6 w-6" />{currentUser?.name} </div>
        </div>}
        {sideBarState ? (
          <MdChevronLeft
            onClick={() => dispatch(sideBarClose())}
            className="ml-auto text-3xl hover:bg-green-700 rounded-full cursor-pointer"
          />
        ) : (
          <>
          {/* <img src="./icons/mobility.png" className="h-8 w-8 "></img> */}
          <MdChevronRight
            onClick={() => dispatch(sideBarOpen())}
            className="ml-auto text-3xl hover:bg-green-700 rounded-full cursor-pointer"
          />
          </>
        )}
      </div>

      <ul className="text-base py-5 text-left ">
        {menu.map((menuItem, idx) => {
          if (checkPermission(menuItem.permissions, currentUser))
            return (
              <li
                key={idx}
                className={`${
                  !sideBarState ? "text-3xl p-4" : ""
                } p-2 hover:bg-green-100 transition-colors ${
                  location.pathname === menuItem.link
                    ? "bg-green-200 text-gray-700 font-semibold border-l-4 border-gray-700 transition-all"
                    : ""
                }`}
              >
                <Link
                  to={menuItem.link}
                  className=" 
                flex items-center justify-start w-full gap-4"
                >
                  {menuItem.icon}
                  {sideBarState && menuItem.title}
                </Link>
              </li>
            );
        })}
      </ul>

      {checkPermission(
        [permissions.stock_transfer, permissions.view_stencil_menu, permissions.view_non_cpkm_tyres, permissions.manage_non_cpkm_tyres, permissions.manage_stencil_menu, permissions.view_stencil_search, permissions.manage_stencil_search],
        currentUser
      ) && (
        <div>
          <p
            className="text-base bg-gray-100 text-center py-2 border-t border-gray-200 cursor-pointer"
            onClick={() => setStencilMenuExpand(!stencilMenuExpand)}
          >
            {sideBarState && "Stencil Menu"}{" "}
            {stencilMenuExpand && (
              <button onClick={() => setStencilMenuExpand(false)}>
                <MdExpandLess />
              </button>
            )}
            {!stencilMenuExpand && (
              <button onClick={() => setStencilMenuExpand(true)}>
                <MdExpandMore />
              </button>
            )}
          </p>
          {stencilMenuExpand && (
            <ul className={`text-base  bg-gray-100 text-gray-700`}>
              {checkPermission(
                [permissions.stock_transfer, permissions.manage_non_cpkm_tyres, permissions.view_non_cpkm_tyres, permissions.view_stencil_menu, permissions.manage_stencil_menu, permissions.view_stencil_search, permissions.manage_stencil_search, permissions.manage_masters, permissions.view_masters],
                currentUser
              ) &&
                stencilMenu.map((menu, idx) => {
                  return (
                    checkPermission(
                      menu.permissions, 
                      currentUser
                    ) &&
                    <li
                      key={idx}
                      className={`relative ${
                        !sideBarState ? "bastext-basep-2" : ""
                      } p-2 hover:bg-green-100 transition-colors ${
                        location.pathname === menu.link
                          ? "bg-green-200 text-gray-700 font-semibold border-l-4 border-gray-700 transition-all"
                          : ""
                      }`}
                    >
                      <Link
                        to={menu.link}
                        className=" 
                flex items-center justify-start w-full gap-4"
                      >
                        {menu.icon}
                        {sideBarState && menu.title}
                        {menu.badge}
                      </Link>
                    </li>
                  );
                })}
            </ul>
          )}
        </div>
      )}

      {checkPermission(
        [ permissions.manage_masters, permissions.view_masters, permissions.view_fleet_master,
          permissions.view_dtp_points, permissions.edit_dtp_points, permissions.delete_dtp_points, permissions.create_dtp_points,
          permissions.view_training_material, permissions.edit_training_material, permissions.delete_training_material, permissions.create_training_material,
        ],
        currentUser
      ) && (
        <div>
          <p
            className="text-base bg-gray-100 text-center py-2 border-t border-gray-200 cursor-pointer"
            onClick={() => setExpanded(!expanded)}
          >
            {sideBarState && "Master Setting"}{" "}
            {expanded && (
              <button onClick={() => setExpanded(false)}>
                <MdExpandLess />
              </button>
            )}
            {!expanded && (
              <button onClick={() => setExpanded(true)}>
                <MdExpandMore />
              </button>
            )}
          </p>
          
          {expanded && (
            <ul className={`text-base  bg-gray-100 text-gray-700`}>
              {(() => {
                const hasOnlyFleetMaster =
                  checkPermission([permissions.view_fleet_master], currentUser) &&
                  !checkPermission([permissions.view_masters, permissions.manage_masters], currentUser);
                const menuItemsToShow = hasOnlyFleetMaster
                  ? masterMenu.filter((m) => m.link === "/fleets")
                  : masterMenu.filter((m) => checkPermission(m.permissions, currentUser));
                return menuItemsToShow.map((menuItem, idx) => (
                  <li
                    key={idx}
                    className={`${
                      !sideBarState ? "bastext-basep-2" : ""
                    } p-2 hover:bg-green-100 transition-colors ${
                      location.pathname === menuItem.link
                        ? "bg-green-200 text-gray-700 font-semibold border-l-4 border-gray-700 transition-all"
                        : ""
                    }`}
                  >
                    <Link
                      to={menuItem.link}
                      className=" 
                flex items-center justify-start w-full gap-4"
                    >
                      {menuItem.icon}
                      {sideBarState && menuItem.title}
                      {menuItem.badge}
                    </Link>
                  </li>
                ));
              })()}
            </ul>
          )}
        </div>
      )}

      <div>
        {checkPermission(
          [permissions.manage_masters, permissions.view_masters,
          ],
          currentUser
        ) && (
          <p
            className="text-base bg-gray-100 text-center py-2 border-t border-gray-200 cursor-pointer"
            onClick={() => setEmailMenuExpanded(!emailMenuExpanded)}
          >
            {sideBarState && "Email Menu"}{" "}
            {emailMenuExpanded && (
              <button onClick={() => setEmailMenuExpanded(false)}>
                <MdExpandLess />
              </button>
            )}
            {!emailMenuExpanded && (
              <button onClick={() => setEmailMenuExpanded(true)}>
                <MdExpandMore />
              </button>
            )}
          </p>
        )}
        
        {emailMenuExpanded && (
          <ul className={`text-base  bg-gray-100 text-gray-700`}>
            {checkPermission(
              [permissions.manage_masters, permissions.view_masters],
              currentUser
            ) &&
              emailMenu.map((menu, idx) => {
                return (
                  <li
                    key={idx}
                    className={`${
                      !sideBarState ? "bastext-basep-2" : ""
                    } p-2 hover:bg-green-100 transition-colors ${
                      location.pathname === menu.link
                        ? "bg-green-200 text-gray-700 font-semibold border-l-4 border-gray-700 transition-all"
                        : ""
                    }`}
                  >
                    <Link
                      to={menu.link}
                      className=" 
                        flex items-center justify-start w-full gap-4"
                    >
                      {menu.icon}
                      {sideBarState && menu.title}
                    </Link>
                  </li>
                );
              })}
          </ul>
        )}
      </div>

         <div>
        {checkPermission(
          [
            permissions.view_vehicle_enrollment_report,
            permissions.view_deenrollment,
            permissions.manage_deenrollment
          ],
          currentUser
        ) && (
          <p
            className="text-base bg-gray-100 text-center py-2 border-t border-gray-20O0 cursor-pointer"
            onClick={() => setVehicleDetailsMenuExpanded(!vehicleDetailsMenuExpanded)}
          >
            {sideBarState && "Vehicle Details"}{" "}
            {vehicleDetailsMenuExpanded && (
              <button onClick={() => setVehicleDetailsMenuExpanded(false)}>
                <MdExpandLess />
              </button>
            )}
            {!vehicleDetailsMenuExpanded && (
              <button onClick={() => setVehicleDetailsMenuExpanded(true)}>
                <MdExpandMore />
              </button>
            )}
          </p>
        )}

        {vehicleDetailsMenuExpanded && (
          <ul className={`text-base  bg-gray-100 text-gray-700`}>
            {checkPermission(
              [
                permissions.view_vehicle_enrollment_report,
                permissions.view_deenrollment,
                permissions.manage_deenrollment
              ],
              currentUser
            ) &&
              vehicleAndDetailsMenu.map((menu, idx) => {
                return (
                  checkPermission(
                    menu.permissions,
                    currentUser
                ) && <li
                    key={idx}
                    className={`${
                      !sideBarState ? "bastext-basep-2" : ""
                    } p-2 hover:bg-green-100 transition-colors ${
                      location.pathname === menu.link
                        ? "bg-green-200 text-gray-700 font-semibold border-l-4 border-gray-700 transition-all"
                        : ""
                    }`}
                  >
                    <Link
                      to={menu.link}
                      className=" 
                        flex items-center justify-start w-full gap-4"
                    >
                      {menu.icon}
                      {sideBarState && menu.title}
                    </Link>
                  </li>
                );
              })}
          </ul>
        )}
      </div>  

      <div>
        {checkPermission(
          [ 
            permissions.view_grn_status_report,
            permissions.manage_grns,
            permissions.view_grn_pending_report,
            permissions.view_month_wise_tyre_trend_report,
            permissions.view_fleet_wise_stock_report,
            permissions.view_onwheel_stencil_report,
            permissions.view_inspection_report,
            permissions.daily_tyre_replacement_report,
            permissions.view_scrap_analysis_report,
            permissions.manage_stencil_search,
            permissions.manage_stencil_menu,
            permissions.external_stock_transfer,
            permissions.view_tyre_validation,
            permissions.manage_tyre_validation,
            permissions.view_inspection_trend_report,
            permissions.view_mechancial_issue_report,
            permissions.view_cpkm_report,
            permissions.view_batch_wise_report,
          ],
          currentUser
        ) && (
          <p
            className="text-base bg-gray-100 text-center py-2 border-t border-gray-20O0 cursor-pointer"
            onClick={() => setOperationalMenuExpanded(!operationalMenuExpanded)}
          >
            {sideBarState && "Operational"}{" "}
            {operationalMenuExpanded && (
              <button onClick={() => setOperationalMenuExpanded(false)}>
                <MdExpandLess />
              </button>
            )}
            {!operationalMenuExpanded && (
              <button onClick={() => setOperationalMenuExpanded(true)}>
                <MdExpandMore />
              </button>
            )}
          </p>
        )}

        {operationalMenuExpanded && (
          <ul className={`text-base  bg-gray-100 text-gray-700`}>
            {
              checkPermission(
                [
                  permissions.view_grn_status_report,
                  permissions.manage_grns,
                  permissions.view_grn_pending_report,
                  permissions.view_month_wise_tyre_trend_report,
                  permissions.view_fleet_wise_stock_report,
                  permissions.view_onwheel_stencil_report,
                  permissions.view_inspection_report,
                  permissions.daily_tyre_replacement_report,
                  permissions.view_scrap_analysis_report,
                  permissions.manage_stencil_search,
                  permissions.manage_stencil_menu,
                  permissions.external_stock_transfer,
                  permissions.view_tyre_validation,
                  permissions.manage_tyre_validation,
                  permissions.view_inspection_trend_report,
                  permissions.view_mechancial_issue_report,
                  permissions.view_cpkm_report,
                  permissions.view_batch_wise_report,
                ],
                currentUser
            ) 
            &&
            checkPermission(
              menu.permissions,
              currentUser
          ) && operationalMenu.map((menu, idx) => {
                return (
                  checkPermission(
                    menu.permissions,
                    currentUser
                ) && <li
                    key={idx}
                    className={`${
                      !sideBarState ? "bastext-basep-2" : ""
                    } p-2 hover:bg-green-100 transition-colors ${
                      location.pathname === menu.link
                        ? "bg-green-200 text-gray-700 font-semibold border-l-4 border-gray-700 transition-all"
                        : ""
                    }`}
                  >
                    <Link
                      to={menu.link}
                      className=" 
                        flex items-center justify-start w-full gap-4"
                    >
                      {menu.icon}
                      {sideBarState && menu.title}
                    </Link>
                  </li>
                );
              })}
          </ul>
        )}
      </div>

      <div>
        {checkPermission(
          [
          permissions.view_inspection_pending_report,
          permissions.view_rotation_pending_report,
          permissions.view_alignment_pending_report,
          permissions.view_dtp
          ],
          currentUser
        ) && (
          <p
            className="text-base bg-gray-100 text-center py-2 border-t border-gray-20O0 cursor-pointer"
            onClick={() => setPendingActionsMenuExpanded(!pendingActionsMenuExpanded)}
          >
            {sideBarState && "Pending Actions"}{" "}
            {pendingActionsMenuExpanded && (
              <button onClick={() => setPendingActionsMenuExpanded(false)}>
                <MdExpandLess />
              </button>
            )}
            {!pendingActionsMenuExpanded && (
              <button onClick={() => setPendingActionsMenuExpanded(true)}>
                <MdExpandMore />
              </button>
            )}
          </p>
        )}
        {pendingActionsMenuExpanded && (
          <ul className={`text-base  bg-gray-100 text-gray-700`}>
            {checkPermission(
              [
                permissions.view_inspection_pending_report,
                permissions.view_rotation_pending_report,
                permissions.view_alignment_pending_report,
                permissions.view_dtp
              ],
              currentUser
            ) &&
              pendingActionsMenu.map((menu, idx) => {
                return (
                  checkPermission(
                    menu.permissions,
                    currentUser
                ) && <li
                    key={idx}
                    className={`${
                      !sideBarState ? "bastext-basep-2" : ""
                    } p-2 hover:bg-green-100 transition-colors ${
                      location.pathname === menu.link
                        ? "bg-green-200 text-gray-700 font-semibold border-l-4 border-gray-700 transition-all"
                        : ""
                    }`}
                  >
                    <Link
                      to={menu.link}
                      className=" 
                        flex items-center justify-start w-full gap-4"
                    >
                      {menu.icon}
                      {sideBarState && menu.title}
                    </Link>
                  </li>
                );
              })}
          </ul>
        )}
      </div>

      <div>
        {checkPermission(
          [
          permissions.view_wheel_alignment_report, permissions.view_wheel_alignment_summary_report
          ],
          currentUser
        ) && (
          <p
            className="text-base bg-gray-100 text-center py-2 border-t border-gray-20O0 cursor-pointer"
            onClick={() => setWheelAndAlignmentMenuExpanded(!wheelAndAlignmentMenuExpanded)}
          >
            {sideBarState && "Wheel Alignment"}{" "}
            {wheelAndAlignmentMenuExpanded && (
              <button onClick={() => setWheelAndAlignmentMenuExpanded(false)}>
                <MdExpandLess />
              </button>
            )}
            {!wheelAndAlignmentMenuExpanded && (
              <button onClick={() => setWheelAndAlignmentMenuExpanded(true)}>
                <MdExpandMore />
              </button>
            )}
          </p>
        )}

        {wheelAndAlignmentMenuExpanded && (
          <ul className={`text-base  bg-gray-100 text-gray-700`}>
            {wheelAndAlignmentMenu.map((menu, idx) => {
              return (
                checkPermission(
                  menu.permissions,
                  currentUser
              ) && <li
                  key={idx}
                  className={`${
                    !sideBarState ? "bastext-basep-2" : ""
                  } p-2 hover:bg-green-100 transition-colors ${
                    location.pathname === menu.link
                      ? "bg-green-200 text-gray-700 font-semibold border-l-4 border-gray-700 transition-all"
                      : ""
                  }`}
                >
                  <Link
                    to={menu.link}
                    className=" 
                      flex items-center justify-start w-full gap-4"
                  >
                    {menu.icon}
                    {sideBarState && menu.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        )}

      </div>
        <div className="mb-[0%] mt-4 sticky bg-gray-50 underline justify-center right-0 text-md bottom-0 flex flex-row">
          <Link to="/privacy-policy">
            Privacy Policy</Link>/
          <Link to="/disclaimer">
            Disclaimer</Link>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
